module.exports = __webpack_public_path__ + "img/ic_plus_white.a2363e10.svg";